
import { generateClient } from "aws-amplify/api";
import { createPoBoxReferalPoint, updatePoBoxReferalPoint, deletePoBoxReferalPoint as removePoBoxReferalPoint } from "graphql/customs/mutations";
import { poBoxReferalPointsByDate, getPoBoxReferalPoint as fetchPoBoxReferalPoint } from "graphql/queries";
import { cleanUpData, getDataFromResponse, getNotDeletedItems } from "utils/Api";

const API = generateClient();

export const savePoBoxReferalPoint = async (data) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updatePoBoxReferalPoint : createPoBoxReferalPoint;
    let cleanData = cleanUpData(data);

    delete cleanData["referalPoBox"];
    cleanData["type"] = "PoBoxReferalPoint";

    const addressResponse = await API.graphql({
        query: operation,
        variables: {
            "input": cleanData
        }
    });

    return getDataFromResponse(addressResponse, operationName === "create" ? "createPoBoxReferalPoint" : "updatePoBoxReferalPoint");
};

export const getPoBoxReferalPointes = async (filter = {}, sortDirection = "DESC") => {
    const data = await API.graphql({
        query: poBoxReferalPointsByDate,
        variables: {
            "filter": filter,
            "type": "PoBoxReferalPoint",
            "sortDirection": sortDirection
        }
    })
    return getNotDeletedItems(data, "poBoxReferalPointsByDate");
}

export const getPoBoxReferalPoint = async (addressId) => {
    let addressObject = await API.graphql({
        query: fetchPoBoxReferalPoint,
        variables: {
            id: addressId
        }
    });
    return getDataFromResponse(addressObject, "getPoBoxReferalPoint");
}

export const deletePoBoxReferalPoint = async (addressData) => {
    const deletedAsset = await API.graphql({
        query: removePoBoxReferalPoint,
        variables: {
            input: {
                "id": addressData.id,
            }
        }
    });
    return getDataFromResponse(deletedAsset, "deletePoBoxReferalPoint");
}